var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnDeceptors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-deceptors",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.939,
    height: 43,
    viewBox: "0 0 42.939 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-deceptors-2",
    "data-name": "icn-deceptors",
    opacity: 0.995
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M1184.641,1124.92a1.909,1.909,0,0,0-2.7,0l-4.343,4.338-4.342-4.338a1.907,1.907,0,1,0-2.7,2.7l4.342,4.337-4.342,4.338a1.907,1.907,0,0,0,2.7,2.695l4.342-4.338,4.343,4.338a1.907,1.907,0,0,0,2.7-2.695l-4.343-4.338,4.343-4.337A1.9,1.9,0,0,0,1184.641,1124.92Z",
    transform: "translate(-1155.617 -1116.766)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M1116.637,1075h-35.317a3.829,3.829,0,0,0-3.821,3.816v26.406a3.8,3.8,0,0,0,3.8,3.8h35.317a3.829,3.829,0,0,0,3.82-3.816V1078.8A3.811,3.811,0,0,0,1116.637,1075Zm-.032,26.314a2.163,2.163,0,0,1-2.164,2.162h-9.9a1.831,1.831,0,0,0-1.743,1.268,1.273,1.273,0,0,1-1.212.882h-5.239a1.273,1.273,0,0,1-1.212-.882,1.831,1.831,0,0,0-1.743-1.268h-9.889a2.177,2.177,0,0,1-2.173-2.17v-20.5a2.162,2.162,0,0,1,2.164-2.161h30.935a2.177,2.177,0,0,1,2.172,2.17Z",
    transform: "translate(-1077.5 -1075)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M1169.74,1349.842h-4.7l-.929-3.757h-12.268l-.929,3.757h-4.7a1.648,1.648,0,1,0,0,3.3h23.533a1.648,1.648,0,1,0,0-3.3Z",
    transform: "translate(-1136.503 -1310.138)",
    fill: "#00aafc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDeceptors);
export default __webpack_public_path__ + "static/media/icn-deceptors.4d22668ad03eaf572be4649a2e61fe3a.svg";
export { ForwardRef as ReactComponent };